module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_HelpCircle2_16"],"path":[{"$":{"d":"M8,1A7,7,0,1,1,1,8,7,7,0,0,1,8,1M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,11H7v2H9Zm3-5.25C12,5.12,11.5,3,8.17,3,5.58,3,4.23,4.23,4.1,6H6c.1-1.27,1.7-1.33,2.19-1.33,1.1,0,2.06.45,2.06,1.21C10.31,7.62,7,7.5,7,7.5V10H9V8.75S12,8.56,12,5.75Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_HelpCircle2_16.svg
// module id = TOsN
// module chunks = 1